var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { QualificationsAction, QualificationsFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
/**
 * The Qualifications Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function QualificationsQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), qualificationsData = _c.qualificationsData, error_qualifications = _c.error_qualifications, loading = _c.loading, qualificationsFormData = _c.qualificationsFormData, success_qualifications_form = _c.success_qualifications_form;
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    useEffect(function () {
        questionnaireTimer.startSection("Qualifications and Work History");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!qualificationsData || qualificationsData.length === 0) {
            dispatch(QualificationsAction());
        }
    }, [dispatch]);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Qualifications and Work History");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        setIsSubmitting(true);
        dispatch(QualificationsFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate("/questionnaire/attributes");
    };
    useEffect(function () {
        if (success_qualifications_form && isSubmitting) {
            navigate("/questionnaire/social");
        }
    }, [success_qualifications_form, isSubmitting, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Qualifications and Work History", content: "Now that we understand a little bit more about your job searching activity and your confidence in seeking employment, we'd like to know about your qualifications and work history.", data: qualificationsData, responses: qualificationsFormData, loading: !qualificationsData || qualificationsData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "qualifications-w", width: getQuestionnaireProgressWidth("qualifications", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default QualificationsQuestionnaire;
